import React from "react";
import Container from "react-bootstrap/Container";

import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Stack from "react-bootstrap/Stack";
import { COLOR_TEXT_PRIMARY } from "./colors";
import { AppLink } from "./CommonStyles";

const Footer = styled.div`
  width: 100%;
  padding: 6px 0 4px 0;
  color: ${COLOR_TEXT_PRIMARY};
`;

export const SuperTeacherFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer d-md-none">
      <Footer>
        <Container>
          <div className="row my-1">
            <Stack direction="horizontal" gap={2}>
              <span className="my-auto text-center px-2 ms-auto">
                © 2026 Super Teacher Inc.
              </span>
              <div className="vr" />
              <ul className="text-center nav justify-content-center">
                <li className="nav-item">
                  <AppLink themed to="/terms-of-use/" className="px-2">
                    {t("footer_terms")}
                  </AppLink>
                </li>
                <li className="nav-item">
                  <AppLink themed to="/privacy-policy/" className="px-2">
                    {t("footer_privacy")}
                  </AppLink>
                </li>
                {/* CC BY 4.0 attributions for the standards data. */}
                <li className="nav-item">
                  <AppLink
                    themed
                    to="/standards-attributions/"
                    className="px-2"
                  >
                    {t("footer_attributions")}
                  </AppLink>
                </li>
              </ul>
              {/* Spacer on the right to take up all of the remaining space, pushing everything else to the center */}
              <div className="p-2 ms-auto"></div>
            </Stack>
          </div>
        </Container>
      </Footer>
    </footer>
  );
};
